import React from 'react';
import { login } from '../../models/auth.js';
import './Login.css';
import Cookies from 'universal-cookie';
import config from '../../../config.json';
import axios from '../../helper/axios.js';

const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKOFICCE_V2 = config.backofficeV2[env];
const BACKEND_URL = config.api[env];

const Login = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  componentWillMount() {
    this.handleGetUserData();
  },

//   Função para criar cookies ao rodar localmente
//   localCookies() {
//     const cookies = new Cookies();

//     cookies.set('auth_bo_token', { COLOCAR_AQUI_O_TOKEN });
//     cookies.set('auth_bo_expiration', { COLOCAR_AQUI_O_EXPIRATION });
//     cookies.set('auth_bo_user', { COLOCAR_AQUI_O_USER });
//   },

  async handleGetUserData() {
    const cookies = new Cookies();

    // this.localCookies();

    if (!cookies.get('auth_bo_token')) {
      window.location.href = `${BACKOFICCE_V2}/login`;
      return;
    }

    localStorage.jwtToken = cookies.get('auth_bo_token');
    localStorage.expiration = cookies.get('auth_bo_expiration');
    localStorage.user = cookies.get('auth_bo_user');

    try {
      const permissionsResponse = await axios.get(
        `${BACKEND_URL}/profile/access`,
        {
          headers: { Authorization: `Bearer ${localStorage.jwtToken}` },
        }
      );

      localStorage.permissions = JSON.stringify(
        permissionsResponse.data.permissions
      );

      const searchParams = new URLSearchParams(this.props?.location?.search);
      const callback = searchParams?.get('callback');

      if (callback) {
        this.context.router.replace(callback);
        return;
      }

      window.location.href = `${BACKOFICCE_V2}/schedules`;
    } catch (error) {
      console.error('Erro ao obter permissões:', error);
      window.location.href = `${BACKOFICCE_V2}/login`;
    }
  },

  getInitialState() {
    return {
      error: false,
    };
  },

  handleSubmit(event) {
    event.preventDefault();

    const cookies = new Cookies();

    const email = this.refs.email.value;
    const pass = this.refs.pass.value;

    login(email, pass, result => {
      if (result.login === false) {
        return this.setState({ error: true });
      }

      const { location } = this.props;

      const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
      const isProd = env.includes('prod');

      const domain = isProd ? '.singu.com.br' : '.singu.io';

      cookies.set('auth_bo_token', localStorage.jwtToken, { domain });
      cookies.set('auth_bo_expiration', localStorage.expiration, { domain });
      cookies.set('auth_bo_user', localStorage.user, { domain });
      cookies.set('auth_bo_permissions', localStorage.permissions, { domain });

      if (result.firstLogin) {
        this.context.router.replace('/change-password');
        return;
      }

      if (location.state && location.state.nextPathname) {
        this.context.router.replace(location.state.nextPathname);
        return;
      }

      window.location.href = `${BACKOFICCE_V2}/schedules`;
    });
  },

  render() {
    return (
      <div className="LoginBody">
        <div className="Login">
          <h2>Backoffice Singu</h2>
          <br />
          <form
            className="form-horizontal"
            onSubmit={this.handleSubmit}
          >
            <div className="form-group">
              <label className="col-sm-4 control-label"> E-mail </label>
              <div className="col-sm-4">
                <input
                  ref="email"
                  className="form-control"
                  type="email"
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-4 control-label">Senha</label>
              <div className="col-sm-4">
                <input
                  ref="pass"
                  type="password"
                  className=" form-control"
                  autoComplete="current-password"
                />
              </div>
            </div>

            <div
              className="form-group"
              style={{ width: 364 }}
            >
              <button
                type="submit"
                className="Login-btn btn btn-default"
              >
                Entrar
              </button>
            </div>

            {this.state.error && (
              <div
                className="col-sm-offset-4 col-sm-4 alert alert-danger"
                role="alert"
              >
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>
                Dados inválidos
              </div>
            )}
          </form>
        </div>
      </div>
    );
  },
});

export default Login;

